import { Action, NextBestAction } from '@/types/constants';
import { Icon } from '../Icons/Icon';

type ActionCTAProps = {
  action: NextBestAction | Action;
  onClick: (value?: string | undefined) => void;
  center?: boolean;
  className?: string;
  searchQuery?: string;
  searchAnswer?: string;
};

export const ActionCTA = (props: ActionCTAProps) => {
  const linkCss = `flex flex-row w-full border bg-gray-50 hover:bg-gray-100 border-[var(--bfsearch-border-color)] rounded-md p-2 ${
    props.center ? 'items-center justify-center' : ''
  } ${props.className ?? ''}`;
  const iconCss = 'w-4 h-4 mr-2';
  const labelCss = 'text-sm grow flex items-center';
  const rightIconCssClasses = 'w-5 h-5 ml-2';

  switch (props.action.type) {
    case 'link':
      return (
        <a
          href={props.action.value}
          target="_blank"
          onClick={() => props.onClick(props.action.value)}
          class={linkCss}
        >
          <span class={labelCss}>
            <Icon name={props.action.icon} classes={iconCss} />
            <span>{props.action.label}</span>
          </span>
          <Icon name="ArrowSquareOut" classes={rightIconCssClasses} />
        </a>
      );
    case 'email':
      return (
        <a
          href={`mailto:${props.action.value}`}
          onClick={() => props.onClick(props.action.value)}
          class={linkCss}
        >
          <span class={labelCss}>
            <Icon name={props.action.icon} classes={iconCss} />
            <span>{props.action.label}</span>
          </span>
          <Icon name="ArrowSquareOut" classes={rightIconCssClasses} />
        </a>
      );
    case 'phone':
      return (
        <a
          href={`tel:${props.action.value}`}
          onClick={() => props.onClick(props.action.value)}
          class={linkCss}
        >
          <span class={labelCss}>
            <Icon name={props.action.icon} classes={iconCss} />
            <span>{props.action.label}</span>
          </span>
          <Icon name="ArrowSquareOut" classes={rightIconCssClasses} />
        </a>
      );
    case 'callback':
    case 'function':
      return (
        <button
          type="button"
          class={linkCss}
          onClick={() => {
            props.action.value({
              query: props.searchQuery,
              answer: props.searchAnswer,
            });
            props.onClick();
          }}
        >
          <span class={labelCss}>
            <Icon name={props.action.icon} classes={iconCss} />
            <span>{props.action.label}</span>
          </span>
          <Icon name="CaretRight" classes={rightIconCssClasses} />
        </button>
      );
    default:
      return null;
  }
};
